import * as React from 'react';

export function ProblemSection() {
  return (
    <section className="whyus-problem">
      <style>{`
        .whyus-problem {
          padding: 72px 24px;
          background: #fff;
        }
        .whyus-problem-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .whyus-problem h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .whyus-problem .accent {
          font-size: 18px;
          color: #666;
          margin: 0 0 12px;
        }
        .whyus-problem .intro {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 28px;
        }
        .whyus-problem .intro .highlight {
          font-weight: 600;
          color: #1a1a1a;
        }
        .whyus-fail-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .whyus-fail-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          color: #555;
          padding: 12px 14px;
          background: #fef2f2;
          border-radius: 8px;
        }
        .whyus-fail-list li i {
          color: #c53030;
          font-size: 14px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .whyus-problem h2 {
            font-size: 24px;
          }
          .whyus-fail-list {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="whyus-problem-inner">
        <h2>El changuito online con la rueda rota</h2>
        <p className="accent">Ya probaste comprar en la web del súper. Sabés cómo termina.</p>
        <p className="intro">
          Verdulería con lista por WhatsApp. El súper que te manda <span className="highlight">cualquier marca menos la que pediste</span>. La app que te dice "disponible" y después te llama para avisarte que no hay. <span className="highlight">Mismo changuito, distinta pantalla.</span>
        </p>
        <ul className="whyus-fail-list">
          <li><i className="fa fa-times-circle" /> Pedís manzanas rojas, te mandan las que sobran</li>
          <li><i className="fa fa-times-circle" /> Stock "disponible" que en realidad no existe</li>
          <li><i className="fa fa-times-circle" /> Sin seguimiento: "¿llegó mi pedido?"</li>
          <li><i className="fa fa-times-circle" /> Sustituciones que nadie te consultó</li>
          <li><i className="fa fa-times-circle" /> Web que en el celular no funciona</li>
          <li><i className="fa fa-times-circle" /> "Te llamamos para confirmar"</li>
        </ul>
      </div>
    </section>
  );
}
